import {
  CreateConsultationInput,
  useMedicalHistoryQuery,
  useSymptomsQuery,
  Symptom,
  Maybe,
} from '@/graphql/types'
import React, { Dispatch, useEffect, useState } from 'react'
import { convertEnum } from '../../hooks/typesDisplay'
import { Button, Card } from './Basics'

type Props = {
  input: CreateConsultationInput
  setModal: Dispatch<React.SetStateAction<boolean>>
  setConfirm: Dispatch<React.SetStateAction<boolean>>
  selectedSymptomIds: string[]
}
export const Confirm: React.FC<Props> = ({
  input,
  setModal,
  setConfirm,
  selectedSymptomIds,
}) => {
  const { data } = useMedicalHistoryQuery({
    variables: { id: input.historyId },
  })
  const symptomsData = useSymptomsQuery()

  const [histryString, setHistoryString] = useState<string>('')
  const [selectedSymptom, setSelectedSymptom] = useState<
    | Array<
        Maybe<
          {
            __typename?: 'Symptom' | undefined
          } & Pick<Symptom, 'id' | 'description' | 'createdAt'>
        >
      >
    | undefined
  >()
  useEffect(() => {
    if (input.historyId.length === 0) {
      return
    }
    if (data?.medicalHistory?.body) {
      setHistoryString(data?.medicalHistory?.body)
    }
  }, [input.historyId, data])

  useEffect(() => {
    console.log('props', selectedSymptomIds)
    if (selectedSymptomIds.length === 0) {
      return
    }
    const selected = symptomsData.data?.symptoms?.nodes?.filter((s) => {
      return s && selectedSymptomIds.includes(s.id)
    })
    console.log(selected)
    setSelectedSymptom(selected)
  }, [selectedSymptomIds])

  return (
    <div className="confirm bg-base-light-color pb-10">
      <div className="w-11/12 pc:w-4/12 mx-auto">
        <div className="flex justify-center mx-auto">
          <div className="text-app-color font-black p-5 text-2xl pc:text-lg">
            相談投稿の確認
          </div>
        </div>
        <div className="text-lg">
          <div>
            <p className="pb-3 text-app-color font-extrabold">
              1.今回のご相談の対象者様はどなたですか？
            </p>
            <Card>
              <p>
                <span className="font-extrabold">対象者：</span>
                {convertEnum('ConsultationTarget', input.targetType)}
              </p>
              <p className="pt-3">
                <span className="font-extrabold">年齢：</span>
                {input.age}歳
              </p>
              <p className="pt-3">
                <span className="font-extrabold">性別：</span>
                {convertEnum('Gender', input.gender)}
              </p>
              <p className="font-extrabold pt-3">
                今回ご相談の症状の診断・症状状況
              </p>
              <p>{histryString}</p>
            </Card>
          </div>
          <div className="mt-4">
            <p className="pt-8 pb-3 text-app-color text-lg font-extrabold">
              2.当てはまる症状はありますか？
            </p>
            <Card>
              {selectedSymptom?.map((e) => (
                <div key={e?.id}>
                  <p className="cursor-default checkbox checked p-3 pt-5 mt-2">
                    {e?.description}
                  </p>
                  {selectedSymptom?.indexOf(e) !==
                    selectedSymptom.length - 1 && (
                    <span className="my-3 block border-b border-gray-50 border-dotted"></span>
                  )}
                </div>
              ))}
            </Card>
          </div>
          <div className="mt-4">
            <p className="pt-8 pb-3 text-app-color text-lg font-extrabold">
              3.相談内容を入力してください
            </p>
            <Card>
              <p className="text-lg font-black">タイトル</p>
              <div className="mt-2 mb-2 whitespace-pre-wrap break-words text-lg leading-7 font-nomal font-sans">
                {input.title}
              </div>
              <p className="text-lg font-black">本文</p>
              <div className="mt-2 whitespace-pre-wrap break-words text-lg leading-7 font-nomal font-sans">
                {input.body}
              </div>
            </Card>
          </div>
        </div>
        <div className="flex justify-center mt-10 mx-auto">
          <Button
            className="w-11/12 focus:outline-none focus:ring focus:border-blue-300  bg-link-color hover:bg-link-color"
            onClick={() => setModal(true)}
          >
            送信する
          </Button>
        </div>
        <div className="flex justify-center mt-2 mx-auto">
          <button
            className="text-xl text-link-color underline"
            onClick={() => {
              setConfirm(false)
            }}
          >
            修正する
          </button>
        </div>
      </div>
    </div>
  )
}
